import React, { useState, useEffect } from 'react';

const FinishCycleModal = ({ show, harvests, isLoading, onConfirm, onCancel }) => {
    const [notes, setNotes] = useState('');

    useEffect(() => {
        if (show) setNotes('');
    }, [show]);

    if (!show) return null;

    const sortedHarvests = (harvests || []).slice().sort((a, b) => a.harvestStartDate.localeCompare(b.harvestStartDate));
    const count = sortedHarvests.length;
    const first = sortedHarvests[0]?.harvestStartDate;
    const last = sortedHarvests[count - 1]?.harvestStartDate;
    const lastHarvest = sortedHarvests[count - 1];
    const missingPeakOrEnd = lastHarvest && (lastHarvest.harvestPeakDate == null || lastHarvest.harvestEndDate == null);

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-6 max-w-md w-full shadow-xl">
                <div className="flex items-center gap-3 mb-4">
                    <span className="material-icons text-indigo-600 text-3xl">task_alt</span>
                    <h5 className="font-bold text-gray-800 mb-0">¿Finalizar cultivo?</h5>
                </div>

                <div className="mb-4 px-3 py-2 bg-gray-50 border border-gray-100 rounded-lg text-xs text-gray-600 space-y-1">
                    <div><strong>{count}</strong> cosecha{count !== 1 ? 's' : ''} registrada{count !== 1 ? 's' : ''}</div>
                    {first && <div>Primera: <strong>{first}</strong></div>}
                    {last && <div>Última: <strong>{last}</strong></div>}
                </div>

                {missingPeakOrEnd && (
                    <div className="mb-4 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs font-bold text-amber-600 flex items-start gap-2">
                        <span className="material-icons text-sm">warning</span>
                        No has registrado la fecha pico o de fin de la última cosecha. Puedes finalizar igual, pero esos datos ya no se podrán completar después.
                    </div>
                )}

                <div>
                    <label className="block font-semibold mb-1 text-sm">Notas (Opc.)</label>
                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows={2}
                        className="block w-full p-2 border border-gray-300 rounded text-sm"
                    />
                </div>

                <p className="text-xs text-red-500 font-bold mt-4">
                    Esta acción no se puede deshacer.
                </p>

                <div className="flex gap-3 justify-end mt-4">
                    <button
                        className="px-4 py-2 rounded-lg border border-gray-200 text-sm font-bold text-gray-600 hover:bg-gray-50"
                        onClick={onCancel}
                        disabled={isLoading}
                    >
                        Cancelar
                    </button>
                    <button
                        className="px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-bold hover:bg-indigo-700 flex items-center gap-2 disabled:opacity-60"
                        onClick={() => onConfirm({ notes: notes || null })}
                        disabled={isLoading}
                    >
                        {isLoading
                            ? <>
                                <span className="material-icons text-sm animate-spin">refresh</span>
                                Procesando...
                              </>
                            : <>
                                <span className="material-icons text-sm">check_circle</span>
                                Sí, finalizar
                              </>
                        }
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FinishCycleModal;
